import { useState, useEffect, useCallback } from 'react';

/**
 * Custom hook to track if window is focused/active
 * Replaces WindowContext to eliminate unnecessary provider
 *
 * @returns {boolean} active - true if window is focused, false otherwise
 */
export const useWindowFocus = () => {
  const [active, setActive] = useState(true);

  const handleFocus = useCallback(() => {
    setActive(true);
  }, []);

  const handleBlur = useCallback(() => {
    setActive(false);
  }, []);

  useEffect(() => {
    // Handle page unload
    const handleBeforeUnload = () => {
      localStorage.removeItem('active_rental');
    };

    window.addEventListener('beforeunload', handleBeforeUnload, false);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, [handleFocus, handleBlur]);

  return active;
};

export default useWindowFocus;
